export default "__VITE_ASSET__DuDu0t3W__"